<template>
  <router-link
    :to="{
      name: 'invoices.show',
      params: { invoice_id: invoice.id },
    }"
  >
    <div class="row">
      <div class="col-12 col-lg-2 col-xl-2">
        <p class="text-truncate">
          <span class="data-label d-lg-none">Number:</span>
          <span class="strong">#{{ invoice.xero_number }}</span>
        </p>
      </div>
      <div class="col-12 col-lg-3 col-xl-3">
        <p class="text-truncate">
          <span class="data-label d-lg-none">Client:</span>
          {{ invoice.client.company }}
        </p>
      </div>
      <div class="col-6 col-lg-2 col-xl-2">
        <p class="text-truncate">
          <span class="data-label d-lg-none">Total:</span>
          ${{ invoice.total | currency }}
        </p>
      </div>
      <div class="col-6 col-lg-1 col-xl-1">
        <p class="text-truncate">
          <span class="data-label d-lg-none">Raised:</span>
          {{ invoice.raised | moment("DD/MM/YY") }}
        </p>
      </div>
      <div class="col-6 col-lg-1 col-xl-1">
        <p class="text-truncate">
          <span class="data-label d-lg-none">Due:</span>
          {{ invoice.due | moment("DD/MM/YY") }}
        </p>
      </div>
      <div class="col-6 col-lg-2 col-xl-2 text-end">
        <p>
          <span class="data-label d-lg-none">Status:</span>
          <span
            class="status"
            :class="{
              'status-approved': invoice.status == 'PAID',
              'status-draft': invoice.status == 'DRAFT',
              'status-sent': invoice.status == 'AUTHORISED',
              'status-declined': invoice.status == 'DELETED',
            }"
          >{{ invoice.status }}</span>
          <span v-if="invoice.overdue" class="overdue ms-2">OVERDUE</span>
        </p>
      </div>
    </div>
  </router-link>
</template>

<script>
export default {
  props: {
    invoice: {
      required: true,
      type: Object,
    },
  },
};
</script>

<style scoped>
.overdue {
  border: 1px solid #d9534f;
  color: #d9534f;
  display: inline-block;
  padding: 2px 8px;
  border-radius: 3px;
  font-size: 0.75rem;
}
</style>
